var _regeneratorRuntime = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["children", "autoConnect", "autoDisconnect"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"), require("streamr-client"));else if ("function" == typeof define && define.amd) define(["react", "streamr-client"], e);else {
    var r = "object" == typeof exports ? e(require("react"), require("streamr-client")) : e(t.react, t["streamr-client"]);

    for (var o in r) {
      ("object" == typeof exports ? exports : t)[o] = r[o];
    }
  }
}(this, function (t, e) {
  return function () {
    var r = {
      6314: function _(t, e, r) {
        "use strict";

        var o = ["BigInt64Array", "BigUint64Array", "Float32Array", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray"];

        t.exports = function () {
          for (var t = [], e = 0; e < o.length; e++) {
            "function" == typeof r.g[o[e]] && (t[t.length] = o[e]);
          }

          return t;
        };
      },
      1924: function _(t, e, r) {
        "use strict";

        var o = r(210),
            n = r(5559),
            i = n(o("String.prototype.indexOf"));

        t.exports = function (t, e) {
          var r = o(t, !!e);
          return "function" == typeof r && i(t, ".prototype.") > -1 ? n(r) : r;
        };
      },
      5559: function _(t, e, r) {
        "use strict";

        var o = r(8612),
            n = r(210),
            i = n("%Function.prototype.apply%"),
            u = n("%Function.prototype.call%"),
            a = n("%Reflect.apply%", !0) || o.call(u, i),
            c = n("%Object.getOwnPropertyDescriptor%", !0),
            p = n("%Object.defineProperty%", !0),
            f = n("%Math.max%");
        if (p) try {
          p({}, "a", {
            value: 1
          });
        } catch (t) {
          p = null;
        }

        t.exports = function (t) {
          var e = a(o, u, arguments);

          if (c && p) {
            var r = c(e, "length");
            r.configurable && p(e, "length", {
              value: 1 + f(0, t.length - (arguments.length - 1))
            });
          }

          return e;
        };

        var y = function y() {
          return a(o, i, arguments);
        };

        p ? p(t.exports, "apply", {
          value: y
        }) : t.exports.apply = y;
      },
      251: function _(t, e, r) {
        "use strict";

        var o = r(2215),
            n = r(2584),
            i = r(609),
            u = r(8420),
            a = r(2847),
            c = r(8326),
            p = r(8923),
            f = r(3679),
            y = r(210),
            l = r(1924),
            s = r(1421),
            b = r(9336),
            g = r(7478),
            v = r(6430),
            d = r(6862),
            h = l("Date.prototype.getTime"),
            m = Object.getPrototypeOf,
            S = l("Object.prototype.toString"),
            j = y("%Set%", !0),
            O = l("Map.prototype.has", !0),
            x = l("Map.prototype.get", !0),
            A = l("Map.prototype.size", !0),
            P = l("Set.prototype.add", !0),
            w = l("Set.prototype.delete", !0),
            E = l("Set.prototype.has", !0),
            M = l("Set.prototype.size", !0);

        function _(t, e, r, o) {
          for (var n, i = b(t); (n = i.next()) && !n.done;) {
            if (T(e, n.value, r, o)) return w(t, n.value), !0;
          }

          return !1;
        }

        function k(t) {
          return void 0 === t ? null : "object" != typeof t ? "symbol" != typeof t && ("string" != typeof t && "number" != typeof t || +t == +t) : void 0;
        }

        function I(t, e, r, o, n, i) {
          var u = k(r);
          if (null != u) return u;
          var a = x(e, u),
              c = d({}, n, {
            strict: !1
          });
          return !(void 0 === a && !O(e, u) || !T(o, a, c, i)) && !O(t, u) && T(o, a, c, i);
        }

        function F(t, e, r) {
          var o = k(r);
          return null != o ? o : E(e, o) && !E(t, o);
        }

        function R(t, e, r, o, n, i) {
          for (var u, a, c = b(t); (u = c.next()) && !u.done;) {
            if (T(r, a = u.value, n, i) && T(o, x(e, a), n, i)) return w(t, a), !0;
          }

          return !1;
        }

        function T(t, e, r, y) {
          var l = r || {};
          if (l.strict ? i(t, e) : t === e) return !0;
          if (f(t) !== f(e)) return !1;
          if (!t || !e || "object" != typeof t && "object" != typeof e) return l.strict ? i(t, e) : t == e;
          var g,
              w = y.has(t),
              k = y.has(e);

          if (w && k) {
            if (y.get(t) === y.get(e)) return !0;
          } else g = {};

          return w || y.set(t, g), k || y.set(e, g), function (t, e, r, i) {
            var f, y;
            if (typeof t != typeof e) return !1;
            if (null == t || null == e) return !1;
            if (S(t) !== S(e)) return !1;
            if (n(t) !== n(e)) return !1;
            if (c(t) !== c(e)) return !1;
            var l = t instanceof Error,
                g = e instanceof Error;
            if (l !== g) return !1;
            if ((l || g) && (t.name !== e.name || t.message !== e.message)) return !1;
            var w = u(t),
                k = u(e);
            if (w !== k) return !1;
            if ((w || k) && (t.source !== e.source || a(t) !== a(e))) return !1;
            var U = p(t),
                D = p(e);
            if (U !== D) return !1;
            if ((U || D) && h(t) !== h(e)) return !1;
            if (r.strict && m && m(t) !== m(e)) return !1;
            if (v(t) !== v(e)) return !1;
            var $ = W(t),
                C = W(e);
            if ($ !== C) return !1;

            if ($ || C) {
              if (t.length !== e.length) return !1;

              for (f = 0; f < t.length; f++) {
                if (t[f] !== e[f]) return !1;
              }

              return !0;
            }

            if (typeof t != typeof e) return !1;
            var B = o(t),
                N = o(e);
            if (B.length !== N.length) return !1;

            for (B.sort(), N.sort(), f = B.length - 1; f >= 0; f--) {
              if (B[f] != N[f]) return !1;
            }

            for (f = B.length - 1; f >= 0; f--) {
              if (!T(t[y = B[f]], e[y], r, i)) return !1;
            }

            var q = s(t),
                G = s(e);
            return q === G && ("Set" === q || "Set" === G ? function (t, e, r, o) {
              if (M(t) !== M(e)) return !1;

              for (var n, i, u, a = b(t), c = b(e); (n = a.next()) && !n.done;) {
                if (n.value && "object" == typeof n.value) u || (u = new j()), P(u, n.value);else if (!E(e, n.value)) {
                  if (r.strict) return !1;
                  if (!F(t, e, n.value)) return !1;
                  u || (u = new j()), P(u, n.value);
                }
              }

              if (u) {
                for (; (i = c.next()) && !i.done;) {
                  if (i.value && "object" == typeof i.value) {
                    if (!_(u, i.value, r.strict, o)) return !1;
                  } else if (!r.strict && !E(t, i.value) && !_(u, i.value, r.strict, o)) return !1;
                }

                return 0 === M(u);
              }

              return !0;
            }(t, e, r, i) : "Map" !== q || function (t, e, r, o) {
              if (A(t) !== A(e)) return !1;

              for (var n, i, u, a, c, p, f = b(t), y = b(e); (n = f.next()) && !n.done;) {
                if (a = n.value[0], c = n.value[1], a && "object" == typeof a) u || (u = new j()), P(u, a);else if (void 0 === (p = x(e, a)) && !O(e, a) || !T(c, p, r, o)) {
                  if (r.strict) return !1;
                  if (!I(t, e, a, c, r, o)) return !1;
                  u || (u = new j()), P(u, a);
                }
              }

              if (u) {
                for (; (i = y.next()) && !i.done;) {
                  if (a = i.value[0], p = i.value[1], a && "object" == typeof a) {
                    if (!R(u, t, a, p, r, o)) return !1;
                  } else if (!(r.strict || t.has(a) && T(x(t, a), p, r, o) || R(u, t, a, p, d({}, r, {
                    strict: !1
                  }), o))) return !1;
                }

                return 0 === M(u);
              }

              return !0;
            }(t, e, r, i));
          }(t, e, l, y);
        }

        function W(t) {
          return !(!t || "object" != typeof t || "number" != typeof t.length || "function" != typeof t.copy || "function" != typeof t.slice || t.length > 0 && "number" != typeof t[0] || !(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t)));
        }

        t.exports = function (t, e, r) {
          return T(t, e, r, g());
        };
      },
      8326: function _(t) {
        var e = {}.toString;

        t.exports = Array.isArray || function (t) {
          return "[object Array]" == e.call(t);
        };
      },
      6085: function _(t, e, r) {
        "use strict";

        var o = r(2215),
            n = function n(t) {
          return null != t;
        },
            i = r(5419)(),
            u = r(1924),
            a = Object,
            c = u("Array.prototype.push"),
            p = u("Object.prototype.propertyIsEnumerable"),
            f = i ? Object.getOwnPropertySymbols : null;

        t.exports = function (t, e) {
          if (!n(t)) throw new TypeError("target must be an object");
          var r,
              u,
              y,
              l,
              s,
              b,
              g,
              v = a(t);

          for (r = 1; r < arguments.length; ++r) {
            u = a(arguments[r]), l = o(u);
            var d = i && (Object.getOwnPropertySymbols || f);
            if (d) for (s = d(u), y = 0; y < s.length; ++y) {
              g = s[y], p(u, g) && c(l, g);
            }

            for (y = 0; y < l.length; ++y) {
              b = u[g = l[y]], p(u, g) && (v[g] = b);
            }
          }

          return v;
        };
      },
      6862: function _(t, e, r) {
        "use strict";

        var o = r(4289),
            n = r(5559),
            i = r(6085),
            u = r(854),
            a = r(9966),
            c = n.apply(u()),
            p = function p(t, e) {
          return c(Object, arguments);
        };

        o(p, {
          getPolyfill: u,
          implementation: i,
          shim: a
        }), t.exports = p;
      },
      854: function _(t, e, r) {
        "use strict";

        var o = r(6085);

        t.exports = function () {
          return Object.assign ? function () {
            if (!Object.assign) return !1;

            for (var t = "abcdefghijklmnopqrst", e = t.split(""), r = {}, o = 0; o < e.length; ++o) {
              r[e[o]] = e[o];
            }

            var n = Object.assign({}, r),
                i = "";

            for (var u in n) {
              i += u;
            }

            return t !== i;
          }() || function () {
            if (!Object.assign || !Object.preventExtensions) return !1;
            var t = Object.preventExtensions({
              1: 2
            });

            try {
              Object.assign(t, "xy");
            } catch (e) {
              return "y" === t[1];
            }

            return !1;
          }() ? o : Object.assign : o;
        };
      },
      9966: function _(t, e, r) {
        "use strict";

        var o = r(4289),
            n = r(854);

        t.exports = function () {
          var t = n();
          return o(Object, {
            assign: t
          }, {
            assign: function assign() {
              return Object.assign !== t;
            }
          }), t;
        };
      },
      4289: function _(t, e, r) {
        "use strict";

        var o = r(2215),
            n = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
            i = Object.prototype.toString,
            u = Array.prototype.concat,
            a = Object.defineProperty,
            c = a && function () {
          var t = {};

          try {
            for (var e in a(t, "x", {
              enumerable: !1,
              value: t
            }), t) {
              return !1;
            }

            return t.x === t;
          } catch (t) {
            return !1;
          }
        }(),
            p = function p(t, e, r, o) {
          var n;
          (!(e in t) || "function" == typeof (n = o) && "[object Function]" === i.call(n) && o()) && (c ? a(t, e, {
            configurable: !0,
            enumerable: !1,
            value: r,
            writable: !0
          }) : t[e] = r);
        },
            f = function f(t, e) {
          var r = arguments.length > 2 ? arguments[2] : {},
              i = o(e);
          n && (i = u.call(i, Object.getOwnPropertySymbols(e)));

          for (var a = 0; a < i.length; a += 1) {
            p(t, i[a], e[i[a]], r[i[a]]);
          }
        };

        f.supportsDescriptors = !!c, t.exports = f;
      },
      9336: function _(t, e, r) {
        "use strict";

        var o = r(2584);

        if (r(1405)() || r(5419)()) {
          var n = Symbol.iterator;

          t.exports = function (t) {
            return null != t && void 0 !== t[n] ? t[n]() : o(t) ? Array.prototype[n].call(t) : void 0;
          };
        } else {
          var i = r(5677),
              u = r(9981),
              a = r(210),
              c = a("%Map%", !0),
              p = a("%Set%", !0),
              f = r(1924),
              y = f("Array.prototype.push"),
              l = f("String.prototype.charCodeAt"),
              s = f("String.prototype.slice"),
              b = function b(t) {
            var e = 0;
            return {
              next: function next() {
                var r,
                    o = e >= t.length;
                return o || (r = t[e], e += 1), {
                  done: o,
                  value: r
                };
              }
            };
          },
              g = function g(t, e) {
            if (i(t) || o(t)) return b(t);

            if (u(t)) {
              var r = 0;
              return {
                next: function next() {
                  var e = function (t, e) {
                    if (e + 1 >= t.length) return e + 1;
                    var r = l(t, e);
                    if (r < 55296 || r > 56319) return e + 1;
                    var o = l(t, e + 1);
                    return o < 56320 || o > 57343 ? e + 1 : e + 2;
                  }(t, r),
                      o = s(t, r, e);

                  return r = e, {
                    done: e > t.length,
                    value: o
                  };
                }
              };
            }

            return e && void 0 !== t["_es6-shim iterator_"] ? t["_es6-shim iterator_"]() : void 0;
          };

          if (c || p) {
            var v = r(8379),
                d = r(9572),
                h = f("Map.prototype.forEach", !0),
                m = f("Set.prototype.forEach", !0);
            if ("undefined" == typeof process || !process.versions || !process.versions.node) var S = f("Map.prototype.iterator", !0),
                j = f("Set.prototype.iterator", !0),
                O = function O(t) {
              var e = !1;
              return {
                next: function next() {
                  try {
                    return {
                      done: e,
                      value: e ? void 0 : t.next()
                    };
                  } catch (t) {
                    return e = !0, {
                      done: !0,
                      value: void 0
                    };
                  }
                }
              };
            };
            var x = f("Map.prototype.@@iterator", !0) || f("Map.prototype._es6-shim iterator_", !0),
                A = f("Set.prototype.@@iterator", !0) || f("Set.prototype._es6-shim iterator_", !0);

            t.exports = function (t) {
              return function (t) {
                if (v(t)) {
                  if (S) return O(S(t));
                  if (x) return x(t);

                  if (h) {
                    var e = [];
                    return h(t, function (t, r) {
                      y(e, [r, t]);
                    }), b(e);
                  }
                }

                if (d(t)) {
                  if (j) return O(j(t));
                  if (A) return A(t);

                  if (m) {
                    var r = [];
                    return m(t, function (t) {
                      y(r, t);
                    }), b(r);
                  }
                }
              }(t) || g(t);
            };
          } else t.exports = function (t) {
            if (null != t) return g(t, !0);
          };
        }
      },
      5677: function _(t) {
        var e = {}.toString;

        t.exports = Array.isArray || function (t) {
          return "[object Array]" == e.call(t);
        };
      },
      9804: function _(t) {
        var e = Object.prototype.hasOwnProperty,
            r = Object.prototype.toString;

        t.exports = function (t, o, n) {
          if ("[object Function]" !== r.call(o)) throw new TypeError("iterator must be a function");
          var i = t.length;
          if (i === +i) for (var u = 0; u < i; u++) {
            o.call(n, t[u], u, t);
          } else for (var a in t) {
            e.call(t, a) && o.call(n, t[a], a, t);
          }
        };
      },
      7648: function _(t) {
        "use strict";

        var e = "Function.prototype.bind called on incompatible ",
            r = Array.prototype.slice,
            o = Object.prototype.toString,
            n = "[object Function]";

        t.exports = function (t) {
          var i = this;
          if ("function" != typeof i || o.call(i) !== n) throw new TypeError(e + i);

          for (var u, a = r.call(arguments, 1), c = function c() {
            if (this instanceof u) {
              var e = i.apply(this, a.concat(r.call(arguments)));
              return Object(e) === e ? e : this;
            }

            return i.apply(t, a.concat(r.call(arguments)));
          }, p = Math.max(0, i.length - a.length), f = [], y = 0; y < p; y++) {
            f.push("$" + y);
          }

          if (u = Function("binder", "return function (" + f.join(",") + "){ return binder.apply(this,arguments); }")(c), i.prototype) {
            var l = function l() {};

            l.prototype = i.prototype, u.prototype = new l(), l.prototype = null;
          }

          return u;
        };
      },
      8612: function _(t, e, r) {
        "use strict";

        var o = r(7648);
        t.exports = Function.prototype.bind || o;
      },
      210: function _(t, e, r) {
        "use strict";

        var o,
            n = SyntaxError,
            i = Function,
            u = TypeError,
            a = function a(t) {
          try {
            return i('"use strict"; return (' + t + ").constructor;")();
          } catch (t) {}
        },
            c = Object.getOwnPropertyDescriptor;

        if (c) try {
          c({}, "");
        } catch (t) {
          c = null;
        }

        var p = function p() {
          throw new u();
        },
            f = c ? function () {
          try {
            return p;
          } catch (t) {
            try {
              return c(arguments, "callee").get;
            } catch (t) {
              return p;
            }
          }
        }() : p,
            y = r(1405)(),
            l = Object.getPrototypeOf || function (t) {
          return t.__proto__;
        },
            s = {},
            b = "undefined" == typeof Uint8Array ? o : l(Uint8Array),
            g = {
          "%AggregateError%": "undefined" == typeof AggregateError ? o : AggregateError,
          "%Array%": Array,
          "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? o : ArrayBuffer,
          "%ArrayIteratorPrototype%": y ? l([][Symbol.iterator]()) : o,
          "%AsyncFromSyncIteratorPrototype%": o,
          "%AsyncFunction%": s,
          "%AsyncGenerator%": s,
          "%AsyncGeneratorFunction%": s,
          "%AsyncIteratorPrototype%": s,
          "%Atomics%": "undefined" == typeof Atomics ? o : Atomics,
          "%BigInt%": "undefined" == typeof BigInt ? o : BigInt,
          "%Boolean%": Boolean,
          "%DataView%": "undefined" == typeof DataView ? o : DataView,
          "%Date%": Date,
          "%decodeURI%": decodeURI,
          "%decodeURIComponent%": decodeURIComponent,
          "%encodeURI%": encodeURI,
          "%encodeURIComponent%": encodeURIComponent,
          "%Error%": Error,
          "%eval%": eval,
          "%EvalError%": EvalError,
          "%Float32Array%": "undefined" == typeof Float32Array ? o : Float32Array,
          "%Float64Array%": "undefined" == typeof Float64Array ? o : Float64Array,
          "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? o : FinalizationRegistry,
          "%Function%": i,
          "%GeneratorFunction%": s,
          "%Int8Array%": "undefined" == typeof Int8Array ? o : Int8Array,
          "%Int16Array%": "undefined" == typeof Int16Array ? o : Int16Array,
          "%Int32Array%": "undefined" == typeof Int32Array ? o : Int32Array,
          "%isFinite%": isFinite,
          "%isNaN%": isNaN,
          "%IteratorPrototype%": y ? l(l([][Symbol.iterator]())) : o,
          "%JSON%": "object" == typeof JSON ? JSON : o,
          "%Map%": "undefined" == typeof Map ? o : Map,
          "%MapIteratorPrototype%": "undefined" != typeof Map && y ? l(new Map()[Symbol.iterator]()) : o,
          "%Math%": Math,
          "%Number%": Number,
          "%Object%": Object,
          "%parseFloat%": parseFloat,
          "%parseInt%": parseInt,
          "%Promise%": "undefined" == typeof Promise ? o : Promise,
          "%Proxy%": "undefined" == typeof Proxy ? o : Proxy,
          "%RangeError%": RangeError,
          "%ReferenceError%": ReferenceError,
          "%Reflect%": "undefined" == typeof Reflect ? o : Reflect,
          "%RegExp%": RegExp,
          "%Set%": "undefined" == typeof Set ? o : Set,
          "%SetIteratorPrototype%": "undefined" != typeof Set && y ? l(new Set()[Symbol.iterator]()) : o,
          "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? o : SharedArrayBuffer,
          "%String%": String,
          "%StringIteratorPrototype%": y ? l(""[Symbol.iterator]()) : o,
          "%Symbol%": y ? Symbol : o,
          "%SyntaxError%": n,
          "%ThrowTypeError%": f,
          "%TypedArray%": b,
          "%TypeError%": u,
          "%Uint8Array%": "undefined" == typeof Uint8Array ? o : Uint8Array,
          "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? o : Uint8ClampedArray,
          "%Uint16Array%": "undefined" == typeof Uint16Array ? o : Uint16Array,
          "%Uint32Array%": "undefined" == typeof Uint32Array ? o : Uint32Array,
          "%URIError%": URIError,
          "%WeakMap%": "undefined" == typeof WeakMap ? o : WeakMap,
          "%WeakRef%": "undefined" == typeof WeakRef ? o : WeakRef,
          "%WeakSet%": "undefined" == typeof WeakSet ? o : WeakSet
        },
            v = function t(e) {
          var r;
          if ("%AsyncFunction%" === e) r = a("async function () {}");else if ("%GeneratorFunction%" === e) r = a("function* () {}");else if ("%AsyncGeneratorFunction%" === e) r = a("async function* () {}");else if ("%AsyncGenerator%" === e) {
            var o = t("%AsyncGeneratorFunction%");
            o && (r = o.prototype);
          } else if ("%AsyncIteratorPrototype%" === e) {
            var n = t("%AsyncGenerator%");
            n && (r = l(n.prototype));
          }
          return g[e] = r, r;
        },
            d = {
          "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
          "%ArrayPrototype%": ["Array", "prototype"],
          "%ArrayProto_entries%": ["Array", "prototype", "entries"],
          "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
          "%ArrayProto_keys%": ["Array", "prototype", "keys"],
          "%ArrayProto_values%": ["Array", "prototype", "values"],
          "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
          "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
          "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
          "%BooleanPrototype%": ["Boolean", "prototype"],
          "%DataViewPrototype%": ["DataView", "prototype"],
          "%DatePrototype%": ["Date", "prototype"],
          "%ErrorPrototype%": ["Error", "prototype"],
          "%EvalErrorPrototype%": ["EvalError", "prototype"],
          "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
          "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
          "%FunctionPrototype%": ["Function", "prototype"],
          "%Generator%": ["GeneratorFunction", "prototype"],
          "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
          "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
          "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
          "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
          "%JSONParse%": ["JSON", "parse"],
          "%JSONStringify%": ["JSON", "stringify"],
          "%MapPrototype%": ["Map", "prototype"],
          "%NumberPrototype%": ["Number", "prototype"],
          "%ObjectPrototype%": ["Object", "prototype"],
          "%ObjProto_toString%": ["Object", "prototype", "toString"],
          "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
          "%PromisePrototype%": ["Promise", "prototype"],
          "%PromiseProto_then%": ["Promise", "prototype", "then"],
          "%Promise_all%": ["Promise", "all"],
          "%Promise_reject%": ["Promise", "reject"],
          "%Promise_resolve%": ["Promise", "resolve"],
          "%RangeErrorPrototype%": ["RangeError", "prototype"],
          "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
          "%RegExpPrototype%": ["RegExp", "prototype"],
          "%SetPrototype%": ["Set", "prototype"],
          "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
          "%StringPrototype%": ["String", "prototype"],
          "%SymbolPrototype%": ["Symbol", "prototype"],
          "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
          "%TypedArrayPrototype%": ["TypedArray", "prototype"],
          "%TypeErrorPrototype%": ["TypeError", "prototype"],
          "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
          "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
          "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
          "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
          "%URIErrorPrototype%": ["URIError", "prototype"],
          "%WeakMapPrototype%": ["WeakMap", "prototype"],
          "%WeakSetPrototype%": ["WeakSet", "prototype"]
        },
            h = r(8612),
            m = r(7642),
            S = h.call(Function.call, Array.prototype.concat),
            j = h.call(Function.apply, Array.prototype.splice),
            O = h.call(Function.call, String.prototype.replace),
            x = h.call(Function.call, String.prototype.slice),
            A = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
            P = /\\(\\)?/g,
            w = function w(t) {
          var e = x(t, 0, 1),
              r = x(t, -1);
          if ("%" === e && "%" !== r) throw new n("invalid intrinsic syntax, expected closing `%`");
          if ("%" === r && "%" !== e) throw new n("invalid intrinsic syntax, expected opening `%`");
          var o = [];
          return O(t, A, function (t, e, r, n) {
            o[o.length] = r ? O(n, P, "$1") : e || t;
          }), o;
        },
            E = function E(t, e) {
          var r,
              o = t;

          if (m(d, o) && (o = "%" + (r = d[o])[0] + "%"), m(g, o)) {
            var i = g[o];
            if (i === s && (i = v(o)), void 0 === i && !e) throw new u("intrinsic " + t + " exists, but is not available. Please file an issue!");
            return {
              alias: r,
              name: o,
              value: i
            };
          }

          throw new n("intrinsic " + t + " does not exist!");
        };

        t.exports = function (t, e) {
          if ("string" != typeof t || 0 === t.length) throw new u("intrinsic name must be a non-empty string");
          if (arguments.length > 1 && "boolean" != typeof e) throw new u('"allowMissing" argument must be a boolean');
          var r = w(t),
              o = r.length > 0 ? r[0] : "",
              i = E("%" + o + "%", e),
              a = i.name,
              p = i.value,
              f = !1,
              y = i.alias;
          y && (o = y[0], j(r, S([0, 1], y)));

          for (var l = 1, s = !0; l < r.length; l += 1) {
            var b = r[l],
                v = x(b, 0, 1),
                d = x(b, -1);
            if (('"' === v || "'" === v || "`" === v || '"' === d || "'" === d || "`" === d) && v !== d) throw new n("property names with quotes must have matching quotes");
            if ("constructor" !== b && s || (f = !0), m(g, a = "%" + (o += "." + b) + "%")) p = g[a];else if (null != p) {
              if (!(b in p)) {
                if (!e) throw new u("base intrinsic for " + t + " exists, but the property is not available.");
                return;
              }

              if (c && l + 1 >= r.length) {
                var h = c(p, b);
                p = (s = !!h) && "get" in h && !("originalValue" in h.get) ? h.get : p[b];
              } else s = m(p, b), p = p[b];

              s && !f && (g[a] = p);
            }
          }

          return p;
        };
      },
      1405: function _(t, e, r) {
        "use strict";

        var o = r.g.Symbol,
            n = r(5419);

        t.exports = function () {
          return "function" == typeof o && "function" == typeof Symbol && "symbol" == typeof o("foo") && "symbol" == typeof Symbol("bar") && n();
        };
      },
      5419: function _(t) {
        "use strict";

        t.exports = function () {
          if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
          if ("symbol" == typeof Symbol.iterator) return !0;
          var t = {},
              e = Symbol("test"),
              r = Object(e);
          if ("string" == typeof e) return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(e)) return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;

          for (e in t[e] = 42, t) {
            return !1;
          }

          if ("function" == typeof Object.keys && 0 !== Object.keys(t).length) return !1;
          if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
          var o = Object.getOwnPropertySymbols(t);
          if (1 !== o.length || o[0] !== e) return !1;
          if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;

          if ("function" == typeof Object.getOwnPropertyDescriptor) {
            var n = Object.getOwnPropertyDescriptor(t, e);
            if (42 !== n.value || !0 !== n.enumerable) return !1;
          }

          return !0;
        };
      },
      7642: function _(t, e, r) {
        "use strict";

        var o = r(8612);
        t.exports = o.call(Function.call, Object.prototype.hasOwnProperty);
      },
      2584: function _(t, e, r) {
        "use strict";

        var o = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag,
            n = r(1924)("Object.prototype.toString"),
            i = function i(t) {
          return !(o && t && "object" == typeof t && Symbol.toStringTag in t) && "[object Arguments]" === n(t);
        },
            u = function u(t) {
          return !!i(t) || null !== t && "object" == typeof t && "number" == typeof t.length && t.length >= 0 && "[object Array]" !== n(t) && "[object Function]" === n(t.callee);
        },
            a = function () {
          return i(arguments);
        }();

        i.isLegacyArguments = u, t.exports = a ? i : u;
      },
      3376: function _(t) {
        "use strict";

        if ("function" == typeof BigInt) {
          var e = BigInt.prototype.valueOf;

          t.exports = function (t) {
            return null != t && "boolean" != typeof t && "string" != typeof t && "number" != typeof t && "symbol" != typeof t && "function" != typeof t && ("bigint" == typeof t || function (t) {
              try {
                return e.call(t), !0;
              } catch (t) {}

              return !1;
            }(t));
          };
        } else t.exports = function (t) {
          return !1;
        };
      },
      6814: function _(t, e, r) {
        "use strict";

        var o = r(1924),
            n = o("Boolean.prototype.toString"),
            i = o("Object.prototype.toString"),
            u = "function" == typeof Symbol && !!Symbol.toStringTag;

        t.exports = function (t) {
          return "boolean" == typeof t || null !== t && "object" == typeof t && (u && Symbol.toStringTag in t ? function (t) {
            try {
              return n(t), !0;
            } catch (t) {
              return !1;
            }
          }(t) : "[object Boolean]" === i(t));
        };
      },
      8923: function _(t) {
        "use strict";

        var e = Date.prototype.getDay,
            r = Object.prototype.toString,
            o = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag;

        t.exports = function (t) {
          return "object" == typeof t && null !== t && (o ? function (t) {
            try {
              return e.call(t), !0;
            } catch (t) {
              return !1;
            }
          }(t) : "[object Date]" === r.call(t));
        };
      },
      8379: function _(t) {
        "use strict";

        var e,
            r = "function" == typeof Map && Map.prototype ? Map : null,
            o = "function" == typeof Set && Set.prototype ? Set : null;
        r || (e = function e(t) {
          return !1;
        });
        var n = r ? Map.prototype.has : null,
            i = o ? Set.prototype.has : null;
        e || n || (e = function e(t) {
          return !1;
        }), t.exports = e || function (t) {
          if (!t || "object" != typeof t) return !1;

          try {
            if (n.call(t), i) try {
              i.call(t);
            } catch (t) {
              return !0;
            }
            return t instanceof r;
          } catch (t) {}

          return !1;
        };
      },
      4578: function _(t) {
        "use strict";

        var e = Number.prototype.toString,
            r = Object.prototype.toString,
            o = "function" == typeof Symbol && !!Symbol.toStringTag;

        t.exports = function (t) {
          return "number" == typeof t || "object" == typeof t && (o ? function (t) {
            try {
              return e.call(t), !0;
            } catch (t) {
              return !1;
            }
          }(t) : "[object Number]" === r.call(t));
        };
      },
      8420: function _(t, e, r) {
        "use strict";

        var o,
            n,
            i,
            u,
            a = r(1405)() && "symbol" == typeof Symbol.toStringTag;

        if (a) {
          o = Function.call.bind(Object.prototype.hasOwnProperty), n = Function.call.bind(RegExp.prototype.exec), i = {};

          var c = function c() {
            throw i;
          };

          u = {
            toString: c,
            valueOf: c
          }, "symbol" == typeof Symbol.toPrimitive && (u[Symbol.toPrimitive] = c);
        }

        var p = Object.prototype.toString,
            f = Object.getOwnPropertyDescriptor;
        t.exports = a ? function (t) {
          if (!t || "object" != typeof t) return !1;
          var e = f(t, "lastIndex");
          if (!e || !o(e, "value")) return !1;

          try {
            n(t, u);
          } catch (t) {
            return t === i;
          }
        } : function (t) {
          return !(!t || "object" != typeof t && "function" != typeof t) && "[object RegExp]" === p.call(t);
        };
      },
      9572: function _(t) {
        "use strict";

        var e,
            r = "function" == typeof Map && Map.prototype ? Map : null,
            o = "function" == typeof Set && Set.prototype ? Set : null;
        o || (e = function e(t) {
          return !1;
        });
        var n = r ? Map.prototype.has : null,
            i = o ? Set.prototype.has : null;
        e || i || (e = function e(t) {
          return !1;
        }), t.exports = e || function (t) {
          if (!t || "object" != typeof t) return !1;

          try {
            if (i.call(t), n) try {
              n.call(t);
            } catch (t) {
              return !0;
            }
            return t instanceof o;
          } catch (t) {}

          return !1;
        };
      },
      9981: function _(t) {
        "use strict";

        var e = String.prototype.valueOf,
            r = Object.prototype.toString,
            o = "function" == typeof Symbol && !!Symbol.toStringTag;

        t.exports = function (t) {
          return "string" == typeof t || "object" == typeof t && (o ? function (t) {
            try {
              return e.call(t), !0;
            } catch (t) {
              return !1;
            }
          }(t) : "[object String]" === r.call(t));
        };
      },
      2636: function _(t, e, r) {
        "use strict";

        var o = Object.prototype.toString;

        if (r(1405)()) {
          var n = Symbol.prototype.toString,
              i = /^Symbol\(.*\)$/;

          t.exports = function (t) {
            if ("symbol" == typeof t) return !0;
            if ("[object Symbol]" !== o.call(t)) return !1;

            try {
              return function (t) {
                return "symbol" == typeof t.valueOf() && i.test(n.call(t));
              }(t);
            } catch (t) {
              return !1;
            }
          };
        } else t.exports = function (t) {
          return !1;
        };
      },
      5692: function _(t, e, r) {
        "use strict";

        var o = r(9804),
            n = r(6314),
            i = r(1924),
            u = i("Object.prototype.toString"),
            a = r(1405)() && "symbol" == typeof Symbol.toStringTag,
            c = n(),
            p = i("Array.prototype.indexOf", !0) || function (t, e) {
          for (var r = 0; r < t.length; r += 1) {
            if (t[r] === e) return r;
          }

          return -1;
        },
            f = i("String.prototype.slice"),
            y = {},
            l = r(9949),
            s = Object.getPrototypeOf;

        a && l && s && o(c, function (t) {
          var e = new r.g[t]();
          if (!(Symbol.toStringTag in e)) throw new EvalError("this engine has support for Symbol.toStringTag, but " + t + " does not have the property! Please report this.");
          var o = s(e),
              n = l(o, Symbol.toStringTag);

          if (!n) {
            var i = s(o);
            n = l(i, Symbol.toStringTag);
          }

          y[t] = n.get;
        }), t.exports = function (t) {
          if (!t || "object" != typeof t) return !1;

          if (!a) {
            var e = f(u(t), 8, -1);
            return p(c, e) > -1;
          }

          return !!l && function (t) {
            var e = !1;
            return o(y, function (r, o) {
              if (!e) try {
                e = r.call(t) === o;
              } catch (t) {}
            }), e;
          }(t);
        };
      },
      9949: function _(t, e, r) {
        "use strict";

        var o = r(210)("%Object.getOwnPropertyDescriptor%");
        if (o) try {
          o([], "length");
        } catch (t) {
          o = null;
        }
        t.exports = o;
      },
      1718: function _(t) {
        "use strict";

        var e,
            r = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap : null,
            o = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet : null;
        r || (e = function e(t) {
          return !1;
        });
        var n = r ? r.prototype.has : null,
            i = o ? o.prototype.has : null;
        e || n || (e = function e(t) {
          return !1;
        }), t.exports = e || function (t) {
          if (!t || "object" != typeof t) return !1;

          try {
            if (n.call(t, n), i) try {
              i.call(t, i);
            } catch (t) {
              return !0;
            }
            return t instanceof r;
          } catch (t) {}

          return !1;
        };
      },
      5899: function _(t) {
        "use strict";

        var e,
            r = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap : null,
            o = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet : null;
        r || (e = function e(t) {
          return !1;
        });
        var n = r ? r.prototype.has : null,
            i = o ? o.prototype.has : null;
        e || i || (t.exports = function (t) {
          return !1;
        }), t.exports = e || function (t) {
          if (!t || "object" != typeof t) return !1;

          try {
            if (i.call(t, i), n) try {
              n.call(t, n);
            } catch (t) {
              return !0;
            }
            return t instanceof o;
          } catch (t) {}

          return !1;
        };
      },
      4244: function _(t) {
        "use strict";

        var e = function e(t) {
          return t != t;
        };

        t.exports = function (t, r) {
          return 0 === t && 0 === r ? 1 / t == 1 / r : t === r || !(!e(t) || !e(r));
        };
      },
      609: function _(t, e, r) {
        "use strict";

        var o = r(4289),
            n = r(5559),
            i = r(4244),
            u = r(5624),
            a = r(2281),
            c = n(u(), Object);
        o(c, {
          getPolyfill: u,
          implementation: i,
          shim: a
        }), t.exports = c;
      },
      5624: function _(t, e, r) {
        "use strict";

        var o = r(4244);

        t.exports = function () {
          return "function" == typeof Object.is ? Object.is : o;
        };
      },
      2281: function _(t, e, r) {
        "use strict";

        var o = r(5624),
            n = r(4289);

        t.exports = function () {
          var t = o();
          return n(Object, {
            is: t
          }, {
            is: function is() {
              return Object.is !== t;
            }
          }), t;
        };
      },
      8987: function _(t, e, r) {
        "use strict";

        var o;

        if (!Object.keys) {
          var n = Object.prototype.hasOwnProperty,
              i = Object.prototype.toString,
              u = r(1414),
              a = Object.prototype.propertyIsEnumerable,
              c = !a.call({
            toString: null
          }, "toString"),
              p = a.call(function () {}, "prototype"),
              f = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
              y = function y(t) {
            var e = t.constructor;
            return e && e.prototype === t;
          },
              l = {
            $applicationCache: !0,
            $console: !0,
            $external: !0,
            $frame: !0,
            $frameElement: !0,
            $frames: !0,
            $innerHeight: !0,
            $innerWidth: !0,
            $onmozfullscreenchange: !0,
            $onmozfullscreenerror: !0,
            $outerHeight: !0,
            $outerWidth: !0,
            $pageXOffset: !0,
            $pageYOffset: !0,
            $parent: !0,
            $scrollLeft: !0,
            $scrollTop: !0,
            $scrollX: !0,
            $scrollY: !0,
            $self: !0,
            $webkitIndexedDB: !0,
            $webkitStorageInfo: !0,
            $window: !0
          },
              s = function () {
            if ("undefined" == typeof window) return !1;

            for (var t in window) {
              try {
                if (!l["$" + t] && n.call(window, t) && null !== window[t] && "object" == typeof window[t]) try {
                  y(window[t]);
                } catch (t) {
                  return !0;
                }
              } catch (t) {
                return !0;
              }
            }

            return !1;
          }();

          o = function o(t) {
            var e = null !== t && "object" == typeof t,
                r = "[object Function]" === i.call(t),
                o = u(t),
                a = e && "[object String]" === i.call(t),
                l = [];
            if (!e && !r && !o) throw new TypeError("Object.keys called on a non-object");
            var b = p && r;
            if (a && t.length > 0 && !n.call(t, 0)) for (var g = 0; g < t.length; ++g) {
              l.push(String(g));
            }
            if (o && t.length > 0) for (var v = 0; v < t.length; ++v) {
              l.push(String(v));
            } else for (var d in t) {
              b && "prototype" === d || !n.call(t, d) || l.push(String(d));
            }
            if (c) for (var h = function (t) {
              if ("undefined" == typeof window || !s) return y(t);

              try {
                return y(t);
              } catch (t) {
                return !1;
              }
            }(t), m = 0; m < f.length; ++m) {
              h && "constructor" === f[m] || !n.call(t, f[m]) || l.push(f[m]);
            }
            return l;
          };
        }

        t.exports = o;
      },
      2215: function _(t, e, r) {
        "use strict";

        var o = Array.prototype.slice,
            n = r(1414),
            i = Object.keys,
            u = i ? function (t) {
          return i(t);
        } : r(8987),
            a = Object.keys;
        u.shim = function () {
          return Object.keys ? function () {
            var t = Object.keys(arguments);
            return t && t.length === arguments.length;
          }(1, 2) || (Object.keys = function (t) {
            return n(t) ? a(o.call(t)) : a(t);
          }) : Object.keys = u, Object.keys || u;
        }, t.exports = u;
      },
      1414: function _(t) {
        "use strict";

        var e = Object.prototype.toString;

        t.exports = function (t) {
          var r = e.call(t),
              o = "[object Arguments]" === r;
          return o || (o = "[object Array]" !== r && null !== t && "object" == typeof t && "number" == typeof t.length && t.length >= 0 && "[object Function]" === e.call(t.callee)), o;
        };
      },
      3697: function _(t) {
        "use strict";

        var e = Object,
            r = TypeError;

        t.exports = function () {
          if (null != this && this !== e(this)) throw new r("RegExp.prototype.flags getter called on non-object");
          var t = "";
          return this.global && (t += "g"), this.ignoreCase && (t += "i"), this.multiline && (t += "m"), this.dotAll && (t += "s"), this.unicode && (t += "u"), this.sticky && (t += "y"), t;
        };
      },
      2847: function _(t, e, r) {
        "use strict";

        var o = r(4289),
            n = r(5559),
            i = r(3697),
            u = r(1721),
            a = r(2753),
            c = n(i);
        o(c, {
          getPolyfill: u,
          implementation: i,
          shim: a
        }), t.exports = c;
      },
      1721: function _(t, e, r) {
        "use strict";

        var o = r(3697),
            n = r(4289).supportsDescriptors,
            i = Object.getOwnPropertyDescriptor,
            u = TypeError;

        t.exports = function () {
          if (!n) throw new u("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");

          if ("gim" === /a/gim.flags) {
            var t = i(RegExp.prototype, "flags");
            if (t && "function" == typeof t.get && "boolean" == typeof /a/.dotAll) return t.get;
          }

          return o;
        };
      },
      2753: function _(t, e, r) {
        "use strict";

        var o = r(4289).supportsDescriptors,
            n = r(1721),
            i = Object.getOwnPropertyDescriptor,
            u = Object.defineProperty,
            a = TypeError,
            c = Object.getPrototypeOf,
            p = /a/;

        t.exports = function () {
          if (!o || !c) throw new a("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
          var t = n(),
              e = c(p),
              r = i(e, "flags");
          return r && r.get === t || u(e, "flags", {
            configurable: !0,
            enumerable: !1,
            get: t
          }), t;
        };
      },
      7478: function _(t, e, r) {
        "use strict";

        var o = r(210),
            n = r(1924),
            i = r(7470),
            u = o("%TypeError%"),
            a = o("%WeakMap%", !0),
            c = o("%Map%", !0),
            p = n("WeakMap.prototype.get", !0),
            f = n("WeakMap.prototype.set", !0),
            y = n("WeakMap.prototype.has", !0),
            l = n("Map.prototype.get", !0),
            s = n("Map.prototype.set", !0),
            b = n("Map.prototype.has", !0),
            g = function g(t, e) {
          for (var r, o = t; null !== (r = o.next); o = r) {
            if (r.key === e) return o.next = r.next, r.next = t.next, t.next = r, r;
          }
        };

        t.exports = function () {
          var t,
              e,
              r,
              o = {
            assert: function assert(t) {
              if (!o.has(t)) throw new u("Side channel does not contain " + i(t));
            },
            get: function get(o) {
              if (a && o && ("object" == typeof o || "function" == typeof o)) {
                if (t) return p(t, o);
              } else if (c) {
                if (e) return l(e, o);
              } else if (r) return function (t, e) {
                var r = g(t, e);
                return r && r.value;
              }(r, o);
            },
            has: function has(o) {
              if (a && o && ("object" == typeof o || "function" == typeof o)) {
                if (t) return y(t, o);
              } else if (c) {
                if (e) return b(e, o);
              } else if (r) return function (t, e) {
                return !!g(t, e);
              }(r, o);

              return !1;
            },
            set: function set(o, n) {
              a && o && ("object" == typeof o || "function" == typeof o) ? (t || (t = new a()), f(t, o, n)) : c ? (e || (e = new c()), s(e, o, n)) : (r || (r = {
                key: {},
                next: null
              }), function (t, e, r) {
                var o = g(t, e);
                o ? o.value = r : t.next = {
                  key: e,
                  next: t.next,
                  value: r
                };
              }(r, o, n));
            }
          };
          return o;
        };
      },
      7470: function _(t, e, r) {
        var o = "function" == typeof Map && Map.prototype,
            n = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
            i = o && n && "function" == typeof n.get ? n.get : null,
            u = o && Map.prototype.forEach,
            a = "function" == typeof Set && Set.prototype,
            c = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
            p = a && c && "function" == typeof c.get ? c.get : null,
            f = a && Set.prototype.forEach,
            y = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
            l = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
            s = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
            b = Boolean.prototype.valueOf,
            g = Object.prototype.toString,
            v = Function.prototype.toString,
            d = String.prototype.match,
            h = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
            m = Object.getOwnPropertySymbols,
            S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null,
            j = "function" == typeof Symbol && "object" == typeof Symbol.iterator,
            O = Object.prototype.propertyIsEnumerable,
            x = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (t) {
          return t.__proto__;
        } : null),
            A = r(7165).custom,
            P = A && k(A) ? A : null,
            w = "function" == typeof Symbol && void 0 !== Symbol.toStringTag ? Symbol.toStringTag : null;

        function E(t, e, r) {
          var o = "double" === (r.quoteStyle || e) ? '"' : "'";
          return o + t + o;
        }

        function M(t) {
          return String(t).replace(/"/g, "&quot;");
        }

        function _(t) {
          return !("[object Array]" !== R(t) || w && "object" == typeof t && w in t);
        }

        function k(t) {
          if (j) return t && "object" == typeof t && t instanceof Symbol;
          if ("symbol" == typeof t) return !0;
          if (!t || "object" != typeof t || !S) return !1;

          try {
            return S.call(t), !0;
          } catch (t) {}

          return !1;
        }

        t.exports = function t(e, r, o, n) {
          var a = r || {};
          if (F(a, "quoteStyle") && "single" !== a.quoteStyle && "double" !== a.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
          if (F(a, "maxStringLength") && ("number" == typeof a.maxStringLength ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : null !== a.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
          var c = !F(a, "customInspect") || a.customInspect;
          if ("boolean" != typeof c) throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
          if (F(a, "indent") && null !== a.indent && "\t" !== a.indent && !(parseInt(a.indent, 10) === a.indent && a.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
          if (void 0 === e) return "undefined";
          if (null === e) return "null";
          if ("boolean" == typeof e) return e ? "true" : "false";
          if ("string" == typeof e) return W(e, a);
          if ("number" == typeof e) return 0 === e ? 1 / 0 / e > 0 ? "0" : "-0" : String(e);
          if ("bigint" == typeof e) return String(e) + "n";
          var g = void 0 === a.depth ? 5 : a.depth;
          if (void 0 === o && (o = 0), o >= g && g > 0 && "object" == typeof e) return _(e) ? "[Array]" : "[Object]";

          var m,
              O = function (t, e) {
            var r;
            if ("\t" === t.indent) r = "\t";else {
              if (!("number" == typeof t.indent && t.indent > 0)) return null;
              r = Array(t.indent + 1).join(" ");
            }
            return {
              base: r,
              prev: Array(e + 1).join(r)
            };
          }(a, o);

          if (void 0 === n) n = [];else if (T(n, e) >= 0) return "[Circular]";

          function A(e, r, i) {
            if (r && (n = n.slice()).push(r), i) {
              var u = {
                depth: a.depth
              };
              return F(a, "quoteStyle") && (u.quoteStyle = a.quoteStyle), t(e, u, o + 1, n);
            }

            return t(e, a, o + 1, n);
          }

          if ("function" == typeof e) {
            var I = function (t) {
              if (t.name) return t.name;
              var e = d.call(v.call(t), /^function\s*([\w$]+)/);
              return e ? e[1] : null;
            }(e),
                U = N(e, A);

            return "[Function" + (I ? ": " + I : " (anonymous)") + "]" + (U.length > 0 ? " { " + U.join(", ") + " }" : "");
          }

          if (k(e)) {
            var q = j ? String(e).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : S.call(e);
            return "object" != typeof e || j ? q : D(q);
          }

          if ((m = e) && "object" == typeof m && ("undefined" != typeof HTMLElement && m instanceof HTMLElement || "string" == typeof m.nodeName && "function" == typeof m.getAttribute)) {
            for (var G = "<" + String(e.nodeName).toLowerCase(), L = e.attributes || [], z = 0; z < L.length; z++) {
              G += " " + L[z].name + "=" + E(M(L[z].value), "double", a);
            }

            return G += ">", e.childNodes && e.childNodes.length && (G += "..."), G + "</" + String(e.nodeName).toLowerCase() + ">";
          }

          if (_(e)) {
            if (0 === e.length) return "[]";
            var J = N(e, A);
            return O && !function (t) {
              for (var e = 0; e < t.length; e++) {
                if (T(t[e], "\n") >= 0) return !1;
              }

              return !0;
            }(J) ? "[" + B(J, O) + "]" : "[ " + J.join(", ") + " ]";
          }

          if (function (t) {
            return !("[object Error]" !== R(t) || w && "object" == typeof t && w in t);
          }(e)) {
            var V = N(e, A);
            return 0 === V.length ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + V.join(", ") + " }";
          }

          if ("object" == typeof e && c) {
            if (P && "function" == typeof e[P]) return e[P]();
            if ("function" == typeof e.inspect) return e.inspect();
          }

          if (function (t) {
            if (!i || !t || "object" != typeof t) return !1;

            try {
              i.call(t);

              try {
                p.call(t);
              } catch (t) {
                return !0;
              }

              return t instanceof Map;
            } catch (t) {}

            return !1;
          }(e)) {
            var H = [];
            return u.call(e, function (t, r) {
              H.push(A(r, e, !0) + " => " + A(t, e));
            }), C("Map", i.call(e), H, O);
          }

          if (function (t) {
            if (!p || !t || "object" != typeof t) return !1;

            try {
              p.call(t);

              try {
                i.call(t);
              } catch (t) {
                return !0;
              }

              return t instanceof Set;
            } catch (t) {}

            return !1;
          }(e)) {
            var X = [];
            return f.call(e, function (t) {
              X.push(A(t, e));
            }), C("Set", p.call(e), X, O);
          }

          if (function (t) {
            if (!y || !t || "object" != typeof t) return !1;

            try {
              y.call(t, y);

              try {
                l.call(t, l);
              } catch (t) {
                return !0;
              }

              return t instanceof WeakMap;
            } catch (t) {}

            return !1;
          }(e)) return $("WeakMap");
          if (function (t) {
            if (!l || !t || "object" != typeof t) return !1;

            try {
              l.call(t, l);

              try {
                y.call(t, y);
              } catch (t) {
                return !0;
              }

              return t instanceof WeakSet;
            } catch (t) {}

            return !1;
          }(e)) return $("WeakSet");
          if (function (t) {
            if (!s || !t || "object" != typeof t) return !1;

            try {
              return s.call(t), !0;
            } catch (t) {}

            return !1;
          }(e)) return $("WeakRef");
          if (function (t) {
            return !("[object Number]" !== R(t) || w && "object" == typeof t && w in t);
          }(e)) return D(A(Number(e)));
          if (function (t) {
            if (!t || "object" != typeof t || !h) return !1;

            try {
              return h.call(t), !0;
            } catch (t) {}

            return !1;
          }(e)) return D(A(h.call(e)));
          if (function (t) {
            return !("[object Boolean]" !== R(t) || w && "object" == typeof t && w in t);
          }(e)) return D(b.call(e));
          if (function (t) {
            return !("[object String]" !== R(t) || w && "object" == typeof t && w in t);
          }(e)) return D(A(String(e)));

          if (!function (t) {
            return !("[object Date]" !== R(t) || w && "object" == typeof t && w in t);
          }(e) && !function (t) {
            return !("[object RegExp]" !== R(t) || w && "object" == typeof t && w in t);
          }(e)) {
            var Y = N(e, A),
                K = x ? x(e) === Object.prototype : e instanceof Object || e.constructor === Object,
                Q = e instanceof Object ? "" : "null prototype",
                Z = !K && w && Object(e) === e && w in e ? R(e).slice(8, -1) : Q ? "Object" : "",
                tt = (K || "function" != typeof e.constructor ? "" : e.constructor.name ? e.constructor.name + " " : "") + (Z || Q ? "[" + [].concat(Z || [], Q || []).join(": ") + "] " : "");
            return 0 === Y.length ? tt + "{}" : O ? tt + "{" + B(Y, O) + "}" : tt + "{ " + Y.join(", ") + " }";
          }

          return String(e);
        };

        var I = Object.prototype.hasOwnProperty || function (t) {
          return t in this;
        };

        function F(t, e) {
          return I.call(t, e);
        }

        function R(t) {
          return g.call(t);
        }

        function T(t, e) {
          if (t.indexOf) return t.indexOf(e);

          for (var r = 0, o = t.length; r < o; r++) {
            if (t[r] === e) return r;
          }

          return -1;
        }

        function W(t, e) {
          if (t.length > e.maxStringLength) {
            var r = t.length - e.maxStringLength,
                o = "... " + r + " more character" + (r > 1 ? "s" : "");
            return W(t.slice(0, e.maxStringLength), e) + o;
          }

          return E(t.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, U), "single", e);
        }

        function U(t) {
          var e = t.charCodeAt(0),
              r = {
            8: "b",
            9: "t",
            10: "n",
            12: "f",
            13: "r"
          }[e];
          return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + e.toString(16).toUpperCase();
        }

        function D(t) {
          return "Object(" + t + ")";
        }

        function $(t) {
          return t + " { ? }";
        }

        function C(t, e, r, o) {
          return t + " (" + e + ") {" + (o ? B(r, o) : r.join(", ")) + "}";
        }

        function B(t, e) {
          if (0 === t.length) return "";
          var r = "\n" + e.prev + e.base;
          return r + t.join("," + r) + "\n" + e.prev;
        }

        function N(t, e) {
          var r = _(t),
              o = [];

          if (r) {
            o.length = t.length;

            for (var n = 0; n < t.length; n++) {
              o[n] = F(t, n) ? e(t[n], t) : "";
            }
          }

          var i,
              u = "function" == typeof m ? m(t) : [];

          if (j) {
            i = {};

            for (var a = 0; a < u.length; a++) {
              i["$" + u[a]] = u[a];
            }
          }

          for (var c in t) {
            F(t, c) && (r && String(Number(c)) === c && c < t.length || j && i["$" + c] instanceof Symbol || (/[^\w$]/.test(c) ? o.push(e(c, t) + ": " + e(t[c], t)) : o.push(c + ": " + e(t[c], t))));
          }

          if ("function" == typeof m) for (var p = 0; p < u.length; p++) {
            O.call(t, u[p]) && o.push("[" + e(u[p]) + "]: " + e(t[u[p]], t));
          }
          return o;
        }
      },
      1100: function _(t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9297).createContext(void 0);
        e.default = o;
      },
      3257: function _(t, e, r) {
        "use strict";

        var o = this && this.__createBinding || (Object.create ? function (t, e, r, o) {
          void 0 === o && (o = r), Object.defineProperty(t, o, {
            enumerable: !0,
            get: function get() {
              return e[r];
            }
          });
        } : function (t, e, r, o) {
          void 0 === o && (o = r), t[o] = e[r];
        }),
            n = this && this.__setModuleDefault || (Object.create ? function (t, e) {
          Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
          });
        } : function (t, e) {
          t.default = e;
        }),
            i = this && this.__importStar || function (t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var r in t) {
            "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && o(e, t, r);
          }
          return n(e, t), e;
        },
            u = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a = i(r(9297)),
            c = u(r(251)),
            p = u(r(3025)),
            f = u(r(1100));

        e.default = function (_ref) {
          var t = _ref.children,
              _ref$autoConnect = _ref.autoConnect,
              e = _ref$autoConnect === void 0 ? !0 : _ref$autoConnect,
              _ref$autoDisconnect = _ref.autoDisconnect,
              r = _ref$autoDisconnect === void 0 ? !1 : _ref$autoDisconnect,
              o = _objectWithoutProperties(_ref, _excluded);

          var _a$useState = a.useState(function () {
            return _objectSpread({
              autoConnect: e,
              autoDisconnect: r
            }, o);
          }),
              _a$useState2 = _slicedToArray(_a$useState, 2),
              n = _a$useState2[0],
              i = _a$useState2[1];

          a.useEffect(function () {
            var t = _objectSpread({
              autoConnect: e,
              autoDisconnect: r
            }, o);

            i(function (e) {
              return c.default(e, t) ? e : t;
            });
          }, [e, r, o]);
          var u = a.useMemo(function () {
            return "undefined" == typeof window ? null : new p.default(n);
          }, [n]);
          return a.useEffect(function () {
            return function () {
              u && u.disconnect();
            };
          }, [u]), a.default.createElement(f.default.Provider, {
            value: u
          }, t);
        };
      },
      2629: function _(t, e, r) {
        "use strict";

        var o = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };

        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = e.useSubscription = e.useClient = e.ClientContext = void 0;
        var n = r(1100);
        Object.defineProperty(e, "ClientContext", {
          enumerable: !0,
          get: function get() {
            return o(n).default;
          }
        });
        var i = r(6164);
        Object.defineProperty(e, "useClient", {
          enumerable: !0,
          get: function get() {
            return o(i).default;
          }
        });
        var u = r(4184);
        Object.defineProperty(e, "useSubscription", {
          enumerable: !0,
          get: function get() {
            return o(u).default;
          }
        });
        var a = r(3257);
        Object.defineProperty(e, "default", {
          enumerable: !0,
          get: function get() {
            return o(a).default;
          }
        });
      },
      6164: function _(t, e, r) {
        "use strict";

        var o = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(9297),
            i = o(r(1100));

        e.default = function () {
          return n.useContext(i.default);
        };
      },
      1041: function _(t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9297);

        e.default = function () {
          var t = o.useRef(!0);
          return o.useEffect(function () {
            return function () {
              t.current = !1;
            };
          }, []), o.useCallback(function () {
            return t.current;
          }, []);
        };
      },
      4184: function _(t, e, r) {
        "use strict";

        var o = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };

        Object.defineProperty(e, "__esModule", {
          value: !0
        });

        var n = r(9297),
            i = o(r(251)),
            u = o(r(6164)),
            a = o(r(1041)),
            c = function c(t) {
          console.log(t);
        },
            p = {
          params: {},
          resubscribeCount: 0
        },
            f = "request resubscribe",
            y = "set params",
            l = function l(t, e) {
          switch (e.type) {
            case y:
              return _objectSpread(_objectSpread({}, t), {}, {
                params: e.payload
              });

            case f:
              return _objectSpread(_objectSpread({}, t), {}, {
                resubscribeCount: t.resubscribeCount + 1
              });

            default:
              return t;
          }
        },
            s = function s() {};

        e.default = function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var r = u.default(),
              _e$isActive = e.isActive,
              o = _e$isActive === void 0 ? !0 : _e$isActive,
              _e$isRealtime = e.isRealtime,
              b = _e$isRealtime === void 0 ? !0 : _e$isRealtime,
              _e$onMessage = e.onMessage,
              g = _e$onMessage === void 0 ? s : _e$onMessage,
              _e$onSubscribed = e.onSubscribed,
              v = _e$onSubscribed === void 0 ? s : _e$onSubscribed,
              _e$onResent = e.onResent,
              d = _e$onResent === void 0 ? s : _e$onResent,
              _e$onUnsubscribed = e.onUnsubscribed,
              h = _e$onUnsubscribed === void 0 ? s : _e$onUnsubscribed,
              _e$onError = e.onError,
              m = _e$onError === void 0 ? c : _e$onError,
              S = n.useRef(g);
          S.current = g;
          var j = n.useRef(m);
          j.current = m;

          var _n$useReducer = n.useReducer(l, _objectSpread(_objectSpread({}, p), {}, {
            params: t
          })),
              _n$useReducer2 = _slicedToArray(_n$useReducer, 2),
              _n$useReducer2$ = _n$useReducer2[0],
              O = _n$useReducer2$.params,
              x = _n$useReducer2$.resubscribeCount,
              A = _n$useReducer2[1];

          n.useEffect(function () {
            i.default(O, t) || A({
              type: y,
              payload: t
            });
          }, [t]);
          var P = a.default();
          n.useEffect(function () {
            if (!r) return function () {};

            var t = function t() {
              P() && o && A({
                type: f
              });
            };

            return r.on("disconnected", t), function () {
              r.off("disconnected", t);
            };
          }, [r, o]);

          var _n$useState = n.useState(),
              _n$useState2 = _slicedToArray(_n$useState, 2),
              w = _n$useState2[0],
              E = _n$useState2[1];

          n.useEffect(function () {
            if (!o || !r) return;
            var t = !1;
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _e;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return r[b ? "subscribe" : "resend"](O, function (t, e) {
                        S.current(t, e);
                      });

                    case 3:
                      _e = _context.sent;
                      t || E(_e);
                      _context.next = 10;
                      break;

                    case 7:
                      _context.prev = 7;
                      _context.t0 = _context["catch"](0);
                      j.current(_context.t0);

                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 7]]);
            }))(), function () {
              t = !0, E(void 0);
            };
          }, [r, O, o, b, x]), n.useEffect(function () {
            w && o && v();
          }, [w, o, v]), n.useEffect(function () {
            return function () {
              w && r.unsubscribe(w);
            };
          }, [w]), n.useEffect(function () {
            if (w && o) return w.on("resent", d), w.on("unsubscribed", h), w.on("error", m), function () {
              w.off("resent", d), w.off("unsubscribed", h), w.off("error", m);
            };
          }, [w, o, v, h, m]);
        };
      },
      3679: function _(t, e, r) {
        "use strict";

        var o = r(9981),
            n = r(4578),
            i = r(6814),
            u = r(2636),
            a = r(3376);

        t.exports = function (t) {
          return null == t || "object" != typeof t && "function" != typeof t ? null : o(t) ? "String" : n(t) ? "Number" : i(t) ? "Boolean" : u(t) ? "Symbol" : a(t) ? "BigInt" : void 0;
        };
      },
      1421: function _(t, e, r) {
        "use strict";

        var o = r(8379),
            n = r(9572),
            i = r(1718),
            u = r(5899);

        t.exports = function (t) {
          if (t && "object" == typeof t) {
            if (o(t)) return "Map";
            if (n(t)) return "Set";
            if (i(t)) return "WeakMap";
            if (u(t)) return "WeakSet";
          }

          return !1;
        };
      },
      6430: function _(t, e, r) {
        "use strict";

        var o = r(9804),
            n = r(6314),
            i = r(1924),
            u = i("Object.prototype.toString"),
            a = r(1405)() && "symbol" == typeof Symbol.toStringTag,
            c = n(),
            p = i("String.prototype.slice"),
            f = {},
            y = r(2059),
            l = Object.getPrototypeOf;
        a && y && l && o(c, function (t) {
          if ("function" == typeof r.g[t]) {
            var e = new r.g[t]();
            if (!(Symbol.toStringTag in e)) throw new EvalError("this engine has support for Symbol.toStringTag, but " + t + " does not have the property! Please report this.");
            var o = l(e),
                n = y(o, Symbol.toStringTag);

            if (!n) {
              var i = l(o);
              n = y(i, Symbol.toStringTag);
            }

            f[t] = n.get;
          }
        });
        var s = r(5692);

        t.exports = function (t) {
          return !!s(t) && (a ? function (t) {
            var e = !1;
            return o(f, function (r, o) {
              if (!e) try {
                var n = r.call(t);
                n === o && (e = n);
              } catch (t) {}
            }), e;
          }(t) : p(u(t), 8, -1));
        };
      },
      2059: function _(t, e, r) {
        "use strict";

        var o = r(210)("%Object.getOwnPropertyDescriptor%");
        if (o) try {
          o([], "length");
        } catch (t) {
          o = null;
        }
        t.exports = o;
      },
      9297: function _(e) {
        "use strict";

        e.exports = t;
      },
      3025: function _(t) {
        "use strict";

        t.exports = e;
      },
      7165: function _() {}
    },
        o = {};

    function n(t) {
      var e = o[t];
      if (void 0 !== e) return e.exports;
      var i = o[t] = {
        exports: {}
      };
      return r[t].call(i.exports, i, i.exports, n), i.exports;
    }

    return n.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), n(2629);
  }();
});